module.exports = __webpack_public_path__ + "img/businessLicense.5e1afaf4.jpg";